import { BaseModel } from "sjs-base-model";
import OrderItemModel from "../orderItem/OrderItemModel";
import AddressModel from "../user/AddressModel";

// Returned Api Data sample
// const example = {
//     orderId: 1,
//     created: '2017-07-21T17:32:28Z',
//     state: 'Confirmed',
//     adminFee: 30,
//     vat: 27.82,
//     totalPrice: 174.22,
//     items: [
//         {
//             id: 1,
//             type: "Reference",
//             from: 20210101,
//             to: 20210102,
//             product: "Eurex",
//             price: 60,
//         },
//         {
//             id: 2,
//             type: "Reference",
//             from: 20210102,
//             to: 20210104,
//             product: "Cascade",
//             price: 135,
//         },
//     ],
// };

export default class OrderModel extends BaseModel {
    orderId = 0;
    userId = "";
    created = "";
    updated = "";
    paymentMethod = "";
    paymentId = "";
    state = "";
    type = "";
    adminFee = 0.0;
    discount = 0.0;
    vat = 0.0;
    totalPrice = 0.0;
    items = [OrderItemModel];
    remark = "";
    termsAccepted = false;
    billingAddress = new AddressModel();
    deliveryAddress = new AddressModel();
    email = "";
    tin = "";

    constructor(data) {
        super();
        this.update(data);
    }
}
